import { HttpContext } from '@angular/common/http';
import {
  II18nConfig,
  ServiceIdentifyType,
} from '../services/base/service-config.type';
import {
  REQUEST_CALLER_IDENTIFY,
  REQUEST_SPECIFIC_I18N_CONFIG,
} from '@app/middlewares/user-defined-i18n/user-defined-i18n.constants';
import { isEmpty } from 'lodash';

export const buildServiceIdentifyContext = (
  identify: ServiceIdentifyType,
  options?: { context?: HttpContext; specificI18nConfig?: II18nConfig },
): HttpContext => {
  const { context = new HttpContext(), specificI18nConfig } = options ?? {};

  if (!isEmpty(identify) && !context.get(REQUEST_CALLER_IDENTIFY)) {
    context.set(REQUEST_CALLER_IDENTIFY, identify);
  }

  if (
    !isEmpty(specificI18nConfig) &&
    !context.get(REQUEST_SPECIFIC_I18N_CONFIG)
  ) {
    context.set(REQUEST_SPECIFIC_I18N_CONFIG, specificI18nConfig);
  }

  return context;
};
